export default __webpack_public_path__ + "static/media/how-it-works.d4d23d66.png";